import { Button, FormControlSizes, IconName, isTalosUser, NavButton, Stack, Text, Tooltip } from '@talos/kyoko';
import { useMemo } from 'react';
import { useGetSecurityMasterDeeplinkPath } from '../../containers/Admin/SecurityMaster/helpers';
import { useUser } from '../../hooks';

export const SettingsRelatedActionsButton = ({
  selectedMarketAccounts,
  selectedMarkets,
  symbol,
}: {
  selectedMarkets: string[];
  selectedMarketAccounts: string[];
  symbol: string | undefined;
}) => {
  const user = useUser();

  // Given the selections on the card, creates the path for talos users to instantly navigate to a filtered secmaster blotter
  const getSecurityMasterDeeplinkPath = useGetSecurityMasterDeeplinkPath();
  const securityMasterDeeplinkPath = useMemo(
    () =>
      getSecurityMasterDeeplinkPath({
        Markets: selectedMarkets,
        MarketAccounts: selectedMarketAccounts,
        Symbols: symbol ? [symbol] : undefined,
      }),
    [selectedMarketAccounts, selectedMarkets, symbol, getSecurityMasterDeeplinkPath]
  );

  if (!isTalosUser(user)) {
    return null;
  }

  return (
    <Tooltip
      tooltip={
        <Stack gap="spacing4" p="spacing4">
          <Text>Talos only links</Text>
          <NavButton
            to={securityMasterDeeplinkPath}
            endIcon={IconName.ExternalLink}
            data-testid="md-card-secmaster-link-button"
            size={FormControlSizes.Small}
          >
            Security Master (filtered)
          </NavButton>
        </Stack>
      }
    >
      <Button endIcon={IconName.Link} size={FormControlSizes.Small} data-testid="md-card-links-tooltip-button">
        Links
      </Button>
    </Tooltip>
  );
};
